import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20deep%20red%20and%20golden%20tones%2C%20soft%20bokeh%20texture%2C%20elegant%20luxurious%20background%2C%20Chinese%20aesthetic%20with%20subtle%20pattern&width=1800&height=600&seq=mahjong-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-primary-900/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-xl md:text-3xl font-bold text-background-50 mb-4">
          准备好提升你的麻将技巧了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 leading-relaxed">
          浏览我们的技巧文章，学习高手的实战经验，在麻将竞技的道路上更进一步
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => { navigate('/category/majiang-jiqiao'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-7 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            开始学习技巧
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button
            onClick={() => { navigate('/category/xinshou-rumen'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-7 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm border border-background-50/30 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            新手入门指南
          </button>
        </div>
      </div>
    </section>
  );
}